import React, { useEffect, useState, useRef, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux'

// Redux slices
import { updateObjectData } from './objectSlice';

// SemanticUI components
import { Form, FormField, Flag, Container, Header, Label, TextArea, FormInput, Icon, HeaderContent } from 'semantic-ui-react';

// Style
import './object.css';


/**
 * 
 * @returns 
 */
const Max2Texts = () => {
  // local State
  const [language, setLanguage] = useState('deu');
  const textareasRef = useRef([]);

  // global State
  const dispatch  = useDispatch();
  const editMode    = useSelector((state) => state.object.sections.Texts.edit)
  const object      = useSelector((state) => state.object.data);

  //
  const textLabels = {
    ABHInfo:                { format: 'TEXTAREA', label: 'ABH-Info', placeholder: 'ABH-Info', value: '' },
    HLXInfo:                { format: 'TEXTAREA', label: 'HLX-Info', placeholder: 'HLX-Info', value: '' },
    LHHInfo:                { format: 'TEXTAREA', label: 'LHH-Info', placeholder: 'LHH-Info', value: '' },
    Intro:                  { format: 'TEXTAREA', label: 'Einleitungstext', placeholder: 'Einleitungstext', value: '' },
    Location:               { format: 'TEXTAREA', label: 'Lage', placeholder: 'Lage', value: '' },
    Arrival:                { format: 'TEXTAREA', label: 'Anfahrtsbeschreibung', placeholder: 'Anfahrtsbeschreibung', value: '' },
    NumberOfRooms:          { format: 'INPUT',    label: 'Anzahl Zimmer	', placeholder: 'Anzahl Zimmer	', value: '' },
    FacilityEquipment:      { format: 'TEXTAREA', label: 'Ausstattung Anlage', placeholder: 'Ausstattung Anlage', value: '' },
    AccommodationEquipment: { format: 'TEXTAREA', label: 'Ausstattung Unterbringung', placeholder: 'Ausstattung Unterbringung', value: '' },
    Board:                  { format: 'TEXTAREA', label: 'Verpflegung', placeholder: 'Verpflegung', value: '' },
    Beach:                  { format: 'TEXTAREA', label: 'Strand', placeholder: 'Strand', value: '' },
    BeachDistance:          { format: 'INPUT',    label: 'Entf. Strand', placeholder: 'Entf. Strand', value: '' },
    Children:               { format: 'TEXTAREA', label: 'Kinder', placeholder: 'Kinder', value: '' },
    Sports:                 { format: 'TEXTAREA', label: 'Sport', placeholder: 'Sport', value: '' },
    SportsWithoutFee:       { format: 'TEXTAREA', label: 'Sport ohne Gebühr', placeholder: 'Sport ohne Gebühr', value: '' },
    SportsWithFee:          { format: 'TEXTAREA', label: 'Sport gegen Gebühr', placeholder: 'Sport gegen Gebühr', value: '' },
    Wellness:               { format: 'TEXTAREA', label: 'Wellness', placeholder: 'Wellness', value: '' },
    Entertainment:          { format: 'TEXTAREA', label: 'Unterhaltung/Animation', placeholder: 'Unterhaltung/Animation', value: '' },
    AdditionalInformations: { format: 'TEXTAREA', label: 'Zusatzinfo', placeholder: 'Zusatzinfo', value: '' },
    RenovationInformations: { format: 'TEXTAREA', label: 'Baustelleninfo', placeholder: 'Baustelleninfo', value: '' },
    BinoliInformations:     { format: 'TEXTAREA', label: 'Binoli Info', placeholder: 'Binoli Info', value: '' },
    ImportantNote:          { format: 'TEXTAREA', label: 'Wichtiger Hinweis', placeholder: 'Wichtiger Hinweis', info: 'vom Import ausgeschlossen', value: '' },
  }

  //
  const languages = [
    { key: 'deu', flag: 'de' },
    { key: 'eng', flag: 'uk' }, 
    { key: 'fra', flag: 'fr' },
    { key: 'spa', flag: 'es' }, 
    { key: 'ita', flag: 'it'}
  ];
  
  const adjustTextareaHeight = useCallback(() => {
    for (const index in textareasRef.current) {
      if (Object.prototype.hasOwnProperty.call(textareasRef.current, index)) {
        const textarea = textareasRef.current[index].ref.current;
        if (textarea) {
          textarea.style.height = "auto";
          textarea.style.height = `${textarea.scrollHeight}px`;
        }
      }
    }
  }, [textareasRef]);

  const descriptionTexts = object?.DescriptionsTexts[language]?.Texts;

  useEffect(() => {
    adjustTextareaHeight();
  }, [adjustTextareaHeight, descriptionTexts]);
  

  
  /**
   * 
   * @param {integer} index 
   * @param {string} value 
   */
  const handleInputChange = (index, value) => {
    dispatch(updateObjectData({section: 'Texts', language: language, key: index, value: value}))
  };
  
  
  let foundTexts = false;
  let texts = [];
  if (editMode) {
    for (const textKey in textLabels) {
      if (Object.prototype.hasOwnProperty.call(textLabels, textKey)) {
        const labelValue = textLabels[textKey];
        const textValue = object?.DescriptionsTexts[language]?.Texts[textKey];

        const countChars = typeof textValue !== 'undefined' ? textValue.length : 0;
        const countWords = typeof textValue === 'undefined' || textValue.trim() === "" ? 0 : textValue.trim().split(/\s+/).length; 
        const countCharsLabel = countChars ? <Label basic pointing size='mini' style={{float:'right'}}>Zeichen: {countChars}</Label> : <></>;
        const countWordsLabel = countWords ? <Label basic pointing size='mini' style={{float:'right'}}>Worte: {countWords}</Label> : <></>;

        texts.push(
          <FormField key={textKey} style={{marginBottom: '35px'}}>
            <label>{labelValue.label}</label>
            {labelValue.format === 'TEXTAREA' && (
              <TextArea 
                placeholder = {labelValue.placeholder} 
                value       = {textValue} 
                label       = {{ as: 'a', color: 'red', corner: 'right', icon: 'save' }} 
                ref         = {(el) => { if (el) textareasRef.current[textKey] = el}} // Speichere die Referenz
                style       = {{ overflow: "hidden", resize: "none" }}
                onChange    = {(e) => handleInputChange(textKey, e.target.value)}
              />
            )}
            {labelValue.format === 'INPUT' && (
              <FormInput placeholder={labelValue.placeholder} value={textValue} label={{ as: 'a', color: 'red', corner: 'right', icon: 'save' }} onChange={(e) => handleInputChange(textKey, e.target.value)} />
            )}
            {countCharsLabel}
            {countWordsLabel}
          </FormField>
        );
      }
    }
  } else {
    for (const textKey in descriptionTexts) {
      if (Object.prototype.hasOwnProperty.call(descriptionTexts, textKey)) {
        const textValue = object?.DescriptionsTexts[language]?.Texts[textKey];
        if (textValue) {
          texts.push(
            <Container fluid key={textKey} style={{marginBottom: '25px'}}>
              <Header as='h4'>{textLabels[textKey].label}</Header>
              <p>{textValue}</p>
            </Container>
          );
          foundTexts = true;
        }
      }
    }
  }

  const langIcons = languages.map((lang) => {
    const style = language === lang.key ? {border: '1px solid silver'} : {opacity: '0.4', cursor: 'pointer'};
    return (<Flag key={lang.flag} name={lang.flag} onClick={()=>setLanguage(lang.key)} style={style} />);
  });

  return (
      <Form >
        <div style={{position: 'absolute', top: '-20px', right: '0px'}}>
          {langIcons}
        </div>
        <>
        {(editMode === true || foundTexts) 
          ? <>{texts}</>
          : <><Header as='h4' textAlign='center'><Icon name='times circle outline' /><HeaderContent>Keine Einträge vorhanden</HeaderContent></Header></>
        }
        </>
      </Form>
  )
}

export default Max2Texts;
